module.exports = __webpack_public_path__ + "908e4d2e/img/comment-question-icon.7dd26e04.svg";